import React from 'react';

import styled from 'styled-components';

const ButtonContainer = styled.button<{ disabled: boolean }>`
  margin: 0 24px;
  line-height: 20px;
  min-width: 88px;
  background-color: ${(props) => (props.disabled ? 'rgba(0, 0, 0, 0.12)' : '#1976d2')};
  box-shadow: ${(props) =>
    props.disabled
      ? 'none'
      : `0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2)`};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border: 0;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  z-index: 0;
  transition: all 0.2s ease-out;
  &:active {
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : `0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12),
      0 5px 5px -3px rgba(0, 0, 0, 0.2)`};
  }
  &:hover {
    background-color: ${(props) => (props.disabled ? 'rgba(0, 0, 0, 0.12)' : 'rgb(17, 82, 147)')};
  }
`;

const ButtonText = styled.div<{ disabled: boolean }>`
  margin: 8px;
  color: ${(props) => (props.disabled ? 'rgba(0, 0, 0, 0.26)' : '#fff')};
`;

interface Props {
  onClick: () => void;
  disabled: boolean;
  children: string;
}

const Button = ({ onClick, disabled, children }: Props) => {
  return (
    <ButtonContainer disabled={disabled} onClick={onClick}>
      <ButtonText disabled={disabled}>{children}</ButtonText>
    </ButtonContainer>
  );
};

export default Button;
